'use client'
import * as React from 'react';

var _circle, _circle2, _circle3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletIllustration = function SvgWalletIllustration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 112,
    viewBox: "0 0 116 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 39.5,
    r: 10.5,
    fill: "#D6E4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 78.5,
    r: 18.5,
    fill: "#E5EEFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 43,
    r: 15,
    fill: "#D6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.113 48.714 48.646-5.195-1.027-9.609a2.489 2.489 0 0 0-2.739-2.21L28.6 43.914l.513 4.8Z",
    fill: "#4779FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.616 44.067 53.199-5.681a2.9 2.9 0 0 1 3.191 2.576l3.355 31.414a2.9 2.9 0 0 1-2.576 3.191L35.47 80.94a2.9 2.9 0 0 1-3.191-2.576l-3.663-34.297Z",
    fill: "#A2BDFF"
  })));
};

export { SvgWalletIllustration as ReactComponent };
